import { render } from "./ExpenseCategoriesPage.vue?vue&type=template&id=35918d98&scoped=true"
import script from "./ExpenseCategoriesPage.vue?vue&type=script&lang=js"
export * from "./ExpenseCategoriesPage.vue?vue&type=script&lang=js"

import "./ExpenseCategoriesPage.vue?vue&type=style&index=0&id=35918d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35918d98"]])

export default __exports__